var map = {
	"./assets/images/about-1.jpg": 5158,
	"./assets/images/about-2.jpg": 7361,
	"./assets/images/about-3.jpg": 9204,
	"./assets/images/about-4.jpg": 3839,
	"./assets/images/bodor.png": 3111,
	"./assets/images/custom-manufacturing.jpg": 1755,
	"./assets/images/equipment/altesa.png": 9290,
	"./assets/images/equipment/baraban.png": 1453,
	"./assets/images/equipment/bodor3000.png": 8291,
	"./assets/images/equipment/gl.webp": 2818,
	"./assets/images/equipment/lxcv.png": 5563,
	"./assets/images/equipment/podves.png": 1649,
	"./assets/images/equipment/porkaska.png": 9370,
	"./assets/images/equipment/raycus.png": 8715,
	"./assets/images/equipment/sv-robot.png": 8592,
	"./assets/images/equipment/svpa.png": 4926,
	"./assets/images/equipment/termodiff.png": 9574,
	"./assets/images/equipment/zigov.png": 9255,
	"./assets/images/equipment/zink.png": 5702,
	"./assets/images/hero-image.jpg": 4951,
	"./assets/slide-1.jpg": 15,
	"./assets/slide-2.jpg": 6400,
	"./assets/slide-3.jpg": 7533,
	"./assets/slide_1.png": 1301,
	"./assets/slide_2.png": 5550,
	"./assets/slide_3.png": 8039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5353;